var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovedadds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.016 35.063V9.485a1 1 0 0 0-2 0v23.758a11.494 11.494 0 0 1 2 1.82zM59.019 27.49h-4.001a1 1 0 0 0 0 2.001h4a1 1 0 0 0 0-2zM54.018 17.487c.044.206 4.281-2.063 4.448-2.106a1 1 0 0 0-.895-1.79l-4.001 2.001a1.006 1.006 0 0 0 .448 1.895zM58.466 41.601l-4.001-2a1 1 0 0 0-.895 1.79c.18.049 4.388 2.304 4.448 2.105a1.006 1.006 0 0 0 .448-1.895zM6.12 53.5H5a1 1 0 0 0 0 2h6.403a6.032 6.032 0 0 0 5.982-5.502l1.03-10.393a94.6 94.6 0 0 0-10.073-1.86zM4 24.4v8.182a3.015 3.015 0 0 0 2.77 2.991 88.884 88.884 0 0 1 13.235 2.361V19.048a89.296 89.296 0 0 1-13.234 2.36A3.015 3.015 0 0 0 4 24.4zM31.84 39.015c-2.93 6.38 2.13 14.14 9.17 13.98 7.21.18 12.28-7.98 9.01-14.35a10.03 10.03 0 0 0-18.18.37zm13.88 2.04-5.33 5.33a.99.99 0 0 1-1.42 0l-2.66-2.66a1.008 1.008 0 0 1 0-1.42.996.996 0 0 1 1.41 0l1.96 1.96 4.63-4.62a.997.997 0 0 1 1.41 1.41z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.013 30.992a11.778 11.778 0 0 1 5.001 1.09V11.445c-4.631 1.54-14.535 4.732-24.008 7.113v19.867c2.27.56 4.702 1.22 7.303 1.95a10.503 10.503 0 0 1 .71-2.18 11.98 11.98 0 0 1 10.994-7.203z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedadds);
export default __webpack_public_path__ + "static/media/approved adds.78a11dbcc54352da0625888875fb58ed.svg";
export { ForwardRef as ReactComponent };